export class ExecutionCounter {

  constructor(
    private wrappedVal: number = 0,
  ) {}

  get value(): number {
    return this.wrappedVal;
  }

  increment(toAdd = 1): void {
    this.wrappedVal += toAdd;
  }

  async andThenIncrement<T>(toExecute: Promise<T>): Promise<T> {
    const result = await toExecute;
    this.increment();
    return result;
  }

}
